import { message } from 'antd';
import moment from 'moment';
import fetch from '@/utils/fetch';
import filterNull from '@/utils/filterNull';
import { times, divide } from '@/utils/calc-fns';
import { targetTypeEnums, actionType } from './constants';

const model = {
  state: {
    queryParams: {
      cur_page: 1,
      per_page: 10,
      type: '',
      timeStatus: '',
      title: '',
    },
    listLoading: false,
    tableList: [],
    listTotal: 0,
    couponList: [], // 优惠券list
    couponLoading: false,
    couponShowVisible: false,
    addNumId: null,
    addNumVisible: false,
    addEditType: 'add',
    rangeData: [],
    rangeDataFetching: false,
    peopleData: [],
    peopleDataFetching: false,
    couponData: [],
    couponDataFetching: false,
    couponModalVisible: false,
    couponsList: [],
    selectedCouponList: [],
    total: 0,
    initData: {},
    saveLoading: false, // 保存时loading状态，用于禁止按钮多次点击
  },
  reducers: {
    setState(state, partialState) {
      return { ...state, ...partialState };
    },
  },
  actions: ({ dispatch: { marketingNewWelfare }, getState }) => ({
    // 获取活动列表
    async getList() {
      const { queryParams } = getState().marketingNewWelfare;
      const { cur_page: pageNum, per_page: pageSize, title, type, timeStatus } = queryParams;
      marketingNewWelfare.setState({ listLoading: true });
      const data = await fetch('/saasmerchant/web/activityConfig/getActivityConfigForAdmin', {
        type: 'GET',
        params: {
          pageNum,
          pageSize,
          type,
          title,
          timeStatus,
        },
      });
      marketingNewWelfare.setState({ listLoading: false });
      if (data) {
        marketingNewWelfare.setState({
          tableList: data.records,
          listTotal: data.total,
        });
      }
    },
    async getActivityCoupon(activityConfigId) {
      marketingNewWelfare.setState({ couponLoading: true });
      const data = await fetch('/saasmerchant/web/activityConfig/getCouponByActivityId', {
        type: 'GET',
        params: filterNull({
          activityId: activityConfigId,
        }),
      });
      marketingNewWelfare.setState({ couponLoading: false });
      if (data) {
        marketingNewWelfare.setState({
          couponList: data,
        });
      }
    },
    setDetailVisible(isShow) {
      marketingNewWelfare.setState({
        couponShowVisible: isShow,
      });
    },
    // 搜索
    onSearch(queryParams) {
      marketingNewWelfare.setState({ queryParams });
      marketingNewWelfare.getList();
    },
    // 重置筛选项
    onReset() {
      marketingNewWelfare.setState({
        queryParams: {
          cur_page: 1,
          per_page: 10,
          type: '',
          timeStatus: '',
          title: '',
        },
      });
    },
    // 翻页
    onNav(page) {
      const { queryParams } = getState().marketingNewWelfare;
      marketingNewWelfare.setState({ queryParams: { ...queryParams, cur_page: page } });
      marketingNewWelfare.getList();
    },
    // 更新活动状态，status： 0关闭 1开启 2删除
    async updataActivityStatus(activityId, status) {
      const data = await fetch(
        '/saasmerchant/web/activityConfig/updateActivityConfigStatusByActivityId',
        {
          type: 'POST',
          params: {
            activityId,
            status,
          },
        },
      );
      if (data) {
        marketingNewWelfare.getList();
      }
    },
    // 创建、编辑、复制新人福利活动
    setAddEditType(type, id = '') {
      marketingNewWelfare.setState({ initData: {}, addEditType: type, activityId: id });
    },

    async getCoupon(value) {
      const { union_shop_id, shop_id } = getState().basic;
      marketingNewWelfare.setState({
        couponData: [],
        couponDataFetching: true,
      });
      const data = await fetch('/marketing/platformcoupon/search', {
        type: 'GET',
        params: filterNull({
          search: value,
          union_shop_id,
          shop_id,
        }),
      });
      if (data) {
        const couponData = data.list.map((d) => ({
          label: d.platform_coupon_name,
          id: d.platform_coupon_batch_id,
        }));
        marketingNewWelfare.setState({ couponData });
      }
      marketingNewWelfare.setState({ couponDataFetching: false });
    },
    clearCouponData() {
      marketingNewWelfare.setState({ couponData: [] });
    },
    // 创建活动 -------start
    toggleCouponModalVisible(visible) {
      marketingNewWelfare.setState({
        couponModalVisible: visible,
      });
    },
    async getCouponList(params) {
      const data = await fetch('/saasmerchant/web/coupon/platformCoupons/getCouponsByName', {
        type: 'GET',
        params: { ...params },
      });
      if (data) {
        marketingNewWelfare.setState({ couponsList: data, total: data.length });
      }
    },
    setCouponList(couponsList) {
      marketingNewWelfare.setState({
        couponsList,
      });
    },
    setSelectedCouponList(selectedCouponList) {
      marketingNewWelfare.setState({
        selectedCouponList,
      });
    },
    async getBusiness(value) {
      marketingNewWelfare.setState({
        rangeData: [],
        rangeDataFetching: true,
      });
      const data = await fetch('/saasmerchant/web/fscompany/getCompanyList', {
        type: 'POST',
        useJson: true,
        params: filterNull({
          auditResult: 2, // 	审核状态 1：待处理、2：通过、3：不通过 4：停用
          pageSize: 10000,
          parentCompanyName: value,
        }),
      });
      if (data) {
        const rangeData = data.companyVos.map((d) => ({
          label: d.subCompanyName,
          id: d.companyId,
        }));
        marketingNewWelfare.setState({ rangeData });
      }
      marketingNewWelfare.setState({ rangeDataFetching: false });
    },

    clearRangeData() {
      marketingNewWelfare.setState({ rangeData: [] });
    },

    async saveActivityConfig(params, history) {
      marketingNewWelfare.setState({ saveLoading: true });
      const { addEditType, activityId, selectedCouponList } = getState().marketingNewWelfare;
      const {
        showImgUrl,
        targetType,
        targetList,
        title,
        type,
        time,
        activityCondition,
        awardType,
        awardAmount,
      } = params;
      const allParams = {
        beginTime: time[0].format('YYYY-MM-DD HH:mm:ss'),
        endTime: time[1].format('YYYY-MM-DD HH:mm:ss'),
        title,
        type,
        showImgUrl,
        targetType,
        awardType,
      };
      if (awardType === 0) {
        allParams.rewardConfigList = selectedCouponList.map((item) => {
          return {
            activityCondition,
            conditionCount: activityCondition === 'ORDER' ? 1 : undefined,
            name: item.platformCouponName,
            rewardCount: item.nums,
            rewardLimit: item.repeatLimit,
            rewardItem: item.platformCouponBatchId,
            status: 1,
            type: 0,
          };
        });
      } else if (awardType === 1) {
        allParams.rewardConfigList = [
          {
            activityCondition,
            conditionCount: activityCondition === 'ORDER' ? 1 : undefined,
            awardAmount: times(awardAmount, 100),
            name: '完成任务得返利金',
            type: 1,
          },
        ];
      }
      if (targetType === targetTypeEnums.limit.value && targetList && targetList.length > 0) {
        allParams.targetList = JSON.stringify(
          targetList.map((item) => {
            return {
              company_id: item.key,
              company_name: item.label,
            };
          }),
        );
      }
      if (addEditType === actionType.edit.code) allParams.activityConfigId = activityId;
      const data = await fetch(actionType[addEditType].requestUrl, {
        type: 'POST',
        params: allParams,
        useJson: true,
      });
      marketingNewWelfare.setState({ saveLoading: false });
      if (data) {
        message.success(`新人福利${actionType[addEditType].name}成功`);
        history.push('/marketing/tool/new-welfare');
      }
    },
    async getActivityConfigById() {
      const { activityId } = getState().marketingNewWelfare;
      const data = await fetch('/saasmerchant/web/activityConfig/getActivityConfigById', {
        type: 'GET',
        params: {
          activityId,
        },
      });

      let selectedCouponList = [];
      let activityCondition = 'VERIFY';
      let conditionCount = 1;
      let awardAmount;
      if (data.rewardConfigList && data.rewardConfigList.length > 0) {
        // eslint-disable-next-line prefer-destructuring
        activityCondition = data.rewardConfigList[0].activityCondition;
        // eslint-disable-next-line prefer-destructuring
        conditionCount = data.rewardConfigList[0].conditionCount;
        // eslint-disable-next-line prefer-destructuring
        awardAmount = divide(data.rewardConfigList[0].awardAmount, 100);
        selectedCouponList = data.rewardConfigList.map((item) => {
          return {
            platformCouponBatchId: item.rewardItem,
            platformCouponName: item.name,
            repeatLimit: item.rewardLimit,
            nums: item.rewardCount,
          };
        });
      }

      const { beginTime, endTime, title, type, showImgUrl, targetType, awardType } = data;

      const initData = {
        time: [moment(beginTime), moment(endTime)],
        title,
        type,
        showImgUrl,
        targetType,
        selectedCouponList,
        activityCondition,
        conditionCount,
        awardType,
        awardAmount,
      };
      if (targetType === targetTypeEnums.limit.value) {
        let targetList = [];
        if (JSON.parse(data.targetList) && JSON.parse(data.targetList).length > 0) {
          targetList = JSON.parse(data.targetList).map((item) => {
            return {
              key: item.company_id,
              label: item.company_name,
            };
          });
        }
        initData.targetList = targetList;
      }
      marketingNewWelfare.setState({ initData });
    },
  }),
};

export default model;
